// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
